import type { NavigationItem } from '../side-navigation/NavigationItems.types';

const DEFAULT_TITLE = 'Profile settings';

/**
 * Resolves the title to display in the profile header for a given route.
 * Matches the current pathname against the visible navigation items so that
 * mobile sub-pages (and their nested routes) show their own section title.
 */
function getProfileSubPageTitle(
  pathname: string,
  items: NavigationItem[]
): string {
  const match = items.find(
    item => pathname === item.path || pathname.startsWith(`${item.path}/`)
  );

  return match?.label ?? DEFAULT_TITLE;
}

export { getProfileSubPageTitle };
